import { produce } from 'immer';
import { atom, getDefaultStore } from 'jotai';
import { ErrorService } from 'src/components/Error/ErrorService';
import { NotificationViewDto } from 'src/services/user/types';

export const systemNotificationsAtom = atom<NotificationViewDto[]>([]);
systemNotificationsAtom.debugLabel = "systemNotificationsAtom";


export class NotificationService {

    store = getDefaultStore();


    private MutateNotifications(method: (state: NotificationViewDto[]) => void) {

        let state = this.store.get(systemNotificationsAtom);

        if (state) {
            const newstate = produce(state, (draft: NotificationViewDto[]) => {
                method(draft);
            })

            this.store.set(systemNotificationsAtom, newstate);
        }
    }


    public setNotifications(items: NotificationViewDto[]) {
        this.store.set(systemNotificationsAtom, items);
        const errs = items.filter(i => i.DisplayType === "danger").map(ni => ({
            header: ni.Header,
            htmlMessage: ni.Html,
            message: ni.Message,
            when: ni.StartDate
        }));

        ErrorService.setErrors(errs);
    }

    public setNotificationAsOld(id: string) {
        this.MutateNotifications((state) => {
            const n = state.find(n => n.Id === id);
            if (n) {
                n.NewForUser = false;
            }
        });
    }


    public mergeNotifications(newitems: NotificationViewDto[]) {
        if (!newitems || newitems.length === 0) {
            return;
        }

        this.MutateNotifications((state) => {
            const idHash: Record<string, boolean> = {};
            state.forEach(n => idHash[n.Id] = true);
            state.splice(0, 0, ...newitems.filter(n => !idHash[n.Id]));
        });

        const errs = newitems.filter(i => i.DisplayType === "danger").map(ni => ({
            header: ni.Header,
            htmlMessage: ni.Html,
            message: ni.Message,
            when: ni.StartDate
        }));

        ErrorService.setErrors(errs);

      
    }


}

export const notificationService = new NotificationService();

